import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

// 썸네일 | 콘텐츠명 / 유형 | 등록일
const row: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
};

const thumbnail: CSSObject = {
  flex: 'none',
  width: 52,
  height: 52,
  borderRadius: radius.sm,
  objectFit: 'cover',
  background: color.grey75,
};

const body: CSSObject = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
};

const title: CSSObject = {
  fontSize: 15,
  fontWeight: 600,
  lineHeight: 1.4,
  color: color.text,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const meta: CSSObject = {
  fontSize: 13,
  color: color.textSub,
};

export { row, thumbnail, body, title, meta };
